// extracted by mini-css-extract-plugin
module.exports = {"facilityCategory":"facility_category_facilityCategory__2RExd","facilityCategoryTitle":"facility_category_facilityCategoryTitle__1fwMN"};